<template>
  <div :class="['section-right-content-box', {'isList': showTab}]">
    <div class="page-column-name" v-if="showTab">{{ $route.meta.title }}</div>
    <div v-if="showTab">
      <!-- <myTab :tabInfo="tabInfo" :isDefaultIndex="true" :defaultIndex="activeName" @switch="handleClick" v-if="showTab"></myTab> -->
      <jdTab
        :tabsList="tabInfo"
        :fatherTabAct="activeName"
        @input="handleClick" />
    </div>
    <!-- <div class="box-shadow" v-if="showTab">
      <div class="container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="互动玩法" name="activity"></el-tab-pane>
          <el-tab-pane label="积分兑换" name="credits"></el-tab-pane>
          <el-tab-pane label="礼包弹窗" name="gift"></el-tab-pane>
          <el-tab-pane label="小部件" name="widget"></el-tab-pane>
          <el-tab-pane label="促销方式" name="promotion"></el-tab-pane>
        </el-tabs>
      </div>
    </div> -->
    <div
      class="box-shadow"
      :class="{
        'height-shadow': showTab,
        'height-shadow-none':!showTab,
      }"
      :style="{
        borderRadius: showTab ? '0px 0px 0px 0px' : '16px 16px 0px 0px',
      }">
      <template v-if="activeName == 'activity'">
        <interactList :mainTypes="1" @tabChange="showTabFn" @changeTab="handleClick"></interactList>
      </template>
      <template v-if="activeName == 'credits'">
        <giftList @tabChange="showTabFn"></giftList>
      </template>
      <template v-if="activeName == 'gift'">
        <interactList :mainTypes="2" @tabChange="showTabFn"></interactList>
      </template>
      <template v-if="activeName == 'widget'">
        <widgetList></widgetList>
      </template>
      <template v-if="activeName == 'promotion'">
        <iouList></iouList>
      </template>
      <template v-if="activeName == 'mutualExclusion'">
        <mutualExclusion></mutualExclusion>
      </template>
    </div>
  </div>
</template>
<script>
import interactList from "./list/interactList.vue";
import giftList from "./list/gift_list.vue";
import widgetList from "./cardManage/scratchers.vue";
import iouList from "./iou/index.vue";
import mutualExclusion from "./list/mutualExclusion.vue";
import myTab from "@/components/myTab.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "activityManagement",

  components: {
    interactList,
    giftList,
    widgetList,
    iouList,
    myTab,
    mutualExclusion,
  },

  filters: {},

  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),

    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },

  data() {
    return {
      activeName: "activity",
      showTab: true,
      tabInfo: [
        { title: "互动玩法", tabKey: "activity" },
        { title: "积分兑换", tabKey: "credits" },
        { title: "礼包弹窗", tabKey: "gift" },
        // { title: "小部", tabKey: "widget" },
        { title: "促销方式", tabKey: "promotion" },
        { title: "活动互斥管理", tabKey: "mutualExclusion" },
      ],
    };
  },

  mounted: function () {},

  created() {
    // 埋点
    this.buriedPoint(1, "活动管理", "互动管理", "互动活动");
    // 互动广场携带参数跳转
    if (this.$route.query.sort) {
      this.activeName = this.$route.query.sort;
      console.log("this.activeName------>", this.activeName);
    }
  },

  methods: {
    handleClick(val) {
      if (this.$route.query.activityType) {
        this.$router.push({ query: {} });
      }
      if (val == "activity") {
        this.activeName = "";
        setTimeout(() => {
          this.activeName = "activity";
        }, 1);
      } else if (val == "gift") {
        this.activeName = "";
        setTimeout(() => {
          this.activeName = "gift";
        }, 1);
      } else {
        this.activeName = val;
      }
    },

    showTabFn(val) {
      this.showTab = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  .box-shadow {
    overflow: auto;
  }
  // .top-select {
  //   background: #ffffff;
  //   border-radius: 16px 16px 0 0;
  //   padding: 0 20px;
  //   height: 42px;
  //   line-height: 42px;
  // }

  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #f6f6f6;
    z-index: 1;
  }
}

.isList {
  padding: 16px;
}
.height-shadow-none{
  height: 100%;
}
.height-shadow{
  height: calc(100% - 95px);
}
</style>
